import httpManager from "@/app/shared/utils/httpManager";

export const deleteProgressiveQueueAssignment = async (data) => {
  await httpManager.delete(`/queues/progressive/${data?.ticket_id}/delete/`);
};
